import { SelectProps } from "antd";
import { CSSProperties } from "react";
import { StyledSelect } from "./styled";

export interface CommonSelectorProps<ValueType = any>
  extends SelectProps<ValueType> {
  height?: CSSProperties["height"];
  fontSize?: CSSProperties["fontSize"];
}

const CommonSelector = <ValueType,>({
  height,
  fontSize,
  style,
  ...selectProps
}: CommonSelectorProps<ValueType>) => {
  return (
    <StyledSelect
      {...selectProps}
      $height={height}
      $fontSize={fontSize}
      style={{
        width: "100%",
        ...style,
      }}
    />
  );
};

export default CommonSelector;
